import adminCss from './sass/adminpage.module.scss'

export default function SortNotice(props) {

  return (
    <p className={adminCss['admin-auction-sortnotice']}>
      Columns can be sorted by clicking on the column header.
    </p>
  )
}